<template>
  <b-img-lazy v-if="theme && theme.preview" class="mb-4 pb-2" :src="theme.preview" fluid-grow />
</template>

<script>
export default {
  props: {
    theme: {
      type: Object,
    },
  },
}
</script>
